/* eslint-disable */
import $ from 'jquery'


import Flickity from 'flickity'
import 'flickity-imagesloaded'
import 'flickity-fade'
import 'flickity-hash'



const heroSliders = [...document.querySelectorAll( '.hero-slider' )]
const heroLinks = [...document.querySelectorAll( '.hero-links' )]
const flktys = []

const init = () => {

    if ( heroSliders ) {
      
        heroSliders.forEach( ( s ) => {
          const slider = new Flickity( s, {
            contain: true,
            prevNextButtons: false,
            pageDots: true,
            autoPlay: true,
            wrapAround: false,
            imagesLoaded: true,
            fade: true,
          })

          flktys.push(slider)
      
          window.addEventListener( 'load', function() {
            slider.resize()
            return slider
          })
  
          window.addEventListener( 'resize', function() {
          })
      
        })

        heroLinks.forEach(( hero, i) => {
          hero.addEventListener('click', (e) => {  
            if ( !e.target.matches('.hero-links h6') ) {
              return;
            }
            const selector = e.target.getAttribute('data-selector');
            flktys[i].selectCell( selector );
          } )
        } )
      
    }

}


export default {
  init,
}

